import styled from 'styled-components';

export const UnorderedList = styled.ul`
  margin-block-start: 0;
  margin-top: 12px;
  padding-inline-start: 24px;
`;
